module.exports = __WEBPACK_EXTERNAL_MODULE_elc_service_bus__;